module.exports = {
    nav: {
        home: 'Home',
        about: 'Aubot us',
        yan: 'R D service platform',
        pro: 'Product Center',
        new: 'News Center',
        jabout: 'Join us',
        contact: 'Contact us',
        iupt:'Search CAS number, product name and English name',
    },
    indexs:{
        aouts:"About Tian Hong Da 'an'",
        ke:'Scientific research personnel',
        gao:'50% Highly educated talents',
        pins:"Minimum 5 years industry experience on average",
        success:'A successful audit',
        shun:'ThroughFDA、NMPA',
        tga:'TGA and MFDS reviews',
        quan:'Global clients',
        lc:'Clinical project600',
        zai:"Ongoing business projects30",
        zl:'Patent',
        zlsl:'The number of patents continues to grow, covering the US、',
        orzh:"Europe, Japan, China and South Korea",
        fwfc:'Service scope',
        hese:'Cooperation, pioneering and innovation',
        zqyp:'Be a partner in global drug manufacturing and development, starting with each person, product and service.。',
    },
    about:{
        abCen:'Company profile',
        zhjia:'Expert team',
        zhl:'The quality of compliance',
        qiwen:'The enterprise culture',
        tihxd:'Day HongDa Ann',
        fwts:'Service features',
        shi:'Our Mission',
        hz:'Cooperation, pioneering and innovation',
        yj:'Our Vision',
        zqiu:'Be a partner in global drug manufacturing and development, starting with each person, product and service',
    },
   
    pro:{
        cash:'Cas no.',
        zname:'Chinese name',
        fzs:'Molecular formula',
        jgs:'Structured',
        proxi:'Product information',
        yname:'The English name',
        fzl:'The molecular weight',
        cpsx:'Product attributes',
        yd:'Melting point',
        fd:'The boiling point',
        md:'The density of',
        zdp:'The refractive index',
        sd:'Lightning',
        zctj:'Storage conditions',
        aqxx:'Safety information',
        wxxfh:'Danger symbol',
        // aqxx:'Hazard description',
        wxxbm:'Hazard code',
        hgbm:'The customs code',
        ckwx:'Reference',
        xiazai:'Download',
        cdzl:'Product purity quality report download',
        gs:'Company',
    },
    join:{
        zw:'Position',
        bm:'Department',
        dd:'Place',
        yq:'Requirements',
    },
    cont:{
        ywzx:'Business consulting',
        gszj:'The company switchboard',
        gnywe:'Domestic business mailbox',
        fzgw:'Be responsible for receiving emails related to domestic customers and technical consultation',
        cz:'Fax',
        zjyx:'Securities Mailbox',
        lxdh:'Contact phone number',
        yx:'Email',
        help:'What can we do for you',
        jdlxfs:'Please fill in the short form below to get in touch',
        mz:'The name',
        xing:'The surname',
        zc:'The title',
        gs:'The company',
        yj:'Mail',
        dh:'Phone',
        gj:'Countries',
        gxqfw:'Service of interest',
        zs:'Annotation',
        wjsc:'File upload',
        sbum:'Submit',
        bgxz:'Form Download',
        rgyw:'If you have business consultation, you can download the inquiry form and upload it to us after filling in it.',
        xjd:'Inquiry sheet',
        bzh:'Letter of guarantee',
        wjsc:'File upload',
        djsc:'Click upload',
    },
    more:'To view more',
    news:'Company news',
    td:'Resume Delivery',
    zwlb:'Job listings',
    email:'Email',
    ell:'Contact',
    zpyq:'Job requirement',
    gzzw:'Job responsibilities',
    zpxi:'Recruitment information',
    ywzx:'Business consulting',
    dz:'Address',
    
}


// WEBPACK FOOTER //
// ./src/utils/lang/en.js